import { render, staticRenderFns } from "./BtnSummary.vue?vue&type=template&id=0022449c&scoped=true&"
import script from "./BtnSummary.vue?vue&type=script&lang=js&"
export * from "./BtnSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022449c",
  null
  
)

export default component.exports